<div *transloco="let transloco" class="confirmation">
  <div *ngIf="showSuccess">
    <div class="confirmation__status-box">
      <img src="assets/img/icon-success.svg" />
      <p class="confirmation__invoice-number">
        <b>{{ transloco('InvoiceNumber') }}</b>
        <span>{{invoice?.invoiceNumber}}</span>
      </p>
      <h3 class="confirmation__status">{{ transloco('ThankYou') }}<span>{{ transaction.transactionStatusTypeId === this.transactionStatusTypeId.Completed ? transloco('InvoicePaid') : transloco('PaymentReceived') }}</span></h3>
      <p *ngIf="invoice.sendEmail"
         class="confirmation__status-message"
         [ngClass]="{'mb-0': invoice.sendText, 'mb-8': !invoice.sendText}">{{ transloco('ConfirmationEmailReceiptMessage') }}</p>
      <p *ngIf="invoice.sendText"
         class="confirmation__status-message mb-8">{{ transloco('ConfirmationTextReceiptMessage') }}</p>
    </div>

    <hr class="mx-auto">

    <div class="confirmation__amount-box mx-auto">
      <div class="confirmation__amount-box__item">
        <b>{{ transloco('Paid') }}</b>
        <span class="currency">{{ transaction.tendersTotalAmount }}</span>
      </div>
      <div class="confirmation__amount-box__item">
        <b>{{ transloco('Due') }}</b>
        <span class="currency">{{ transaction.balanceDueCurrencyFormat }}</span>
      </div>
      <div class="confirmation__amount-box__item">
        <b>{{ transloco('DueBy') }}</b>
        <index-pill *ngIf="transaction.transactionStatusTypeId === this.transactionStatusTypeId.Completed"
                    type="light"
                    color="{{ transactionStatusItems?.statusColor }}"
                    class="w-auto">{{ transactionStatusItems?.statusLabel }}</index-pill>
        <span *ngIf="transaction.transactionStatusTypeId !== this.transactionStatusTypeId.Completed">{{ invoice.dueDate }}</span>
      </div>
    </div>

    <hr class="mx-auto mb-25 md:mb-40">

    <div class="block sm:flex flex-row justify-between w-full mx-auto flex-wrap mb-4 sm:mb-16"
         [ngClass]="{'justify-between': transaction.transactionStatusTypeId !== this.transactionStatusTypeId.Completed, 'justify-center': transaction.transactionStatusTypeId === this.transactionStatusTypeId.Completed}">
      <index-button type="secondary"
                    class="confirmation__back-to-invoice mx-auto mb-4"
                    [ngClass]="{'sm:mr-4': transaction.transactionStatusTypeId !== this.transactionStatusTypeId.Completed}"
                    size="full"
                    (click)="this.handleBackClick()">{{ transloco('BackToInvoice') }}</index-button>

      <index-button *ngIf="transaction.transactionStatusTypeId !== this.transactionStatusTypeId.Completed"
                    type="primary"
                    class="confirmation__pay-remaining mx-auto mb-4"
                    [ngClass]="{'sm:ml-4': transaction.transactionStatusTypeId !== this.transactionStatusTypeId.Completed}"
                    size="full"
                    (click)="this.handlePayBalanceClick()">{{ transloco('PayRemainingBalance') }}</index-button>
    </div>

  </div>

  <app-download-button data-html2canvas-ignore class="confirmation__download mx-auto" (onDownload)="this.handleDownload($event)"></app-download-button>
</div>

<app-view class="invoice__download" *ngIf="showInvoice"></app-view>
